import Vue from "vue";
import Vuex from "vuex";

import languageModule from "./modules/appLanguage";
import paymentsModule from "./modules/paymentsData";
import reportsModule from "./modules/reportsData";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentHotel:
      JSON.parse(localStorage.getItem("hotel")) ||
      JSON.parse(sessionStorage.getItem("hotel")),
    user:
      JSON.parse(localStorage.getItem("user")) ||
      JSON.parse(sessionStorage.getItem("user")),
    connection:
      JSON.parse(localStorage.getItem("connection")) ||
      JSON.parse(sessionStorage.getItem("connection")),
  },
  modules: {
    language: languageModule,
    reports: reportsModule,
    payments: paymentsModule,
  },
  mutations: {
    setUser: (state, user) => {
      state.user = user;
      if (user !== null) {
        if (user.staySignedIn) {
          localStorage.setItem("user", JSON.stringify(user));
        } else {
          sessionStorage.setItem("user", JSON.stringify(user));
        }
      } else {
        localStorage.removeItem("user");
        sessionStorage.removeItem("user");
      }
    },
    setConnection: (state, connection) => {
      state.connection = connection;
      if (connection !== null) {
        if (state.user.staySignedIn) {
          localStorage.setItem("connection", JSON.stringify(connection));
        } else {
          sessionStorage.setItem("connection", JSON.stringify(connection));
        }
      } else {
        localStorage.removeItem("connection");
        sessionStorage.removeItem("connection");
      }
    },
    selectHotel: (state, hotel) => {
      state.currentHotel = hotel;
      if (hotel !== null) {
        if (state.user.staySignedIn) {
          localStorage.setItem("hotel", JSON.stringify(hotel));
        } else {
          sessionStorage.setItem("hotel", JSON.stringify(hotel));
        }
      } else {
        localStorage.removeItem("hotel");
        sessionStorage.removeItem("hotel");
      }
    },
  },
  actions: {
    setUser: (context, user) => {
      context.commit("setUser", user);
    },
    setConnection: (context, connection) => {
      context.commit("setConnection", connection);
    },
    selectHotel: (context, hotel) => {
      context.commit("selectHotel", hotel);
      if (hotel) {
        context.dispatch("payments/resetOverview", context, { root: true });
      }
    },
    clearSession: (context) => {
      context.commit("setUser", null);
      context.commit("selectHotel", null);
      context.commit("setConnection", null);
    },
  },
});
